import React, { useEffect, useRef, useState } from 'react';
import { Form, Input, Button, Upload, Popconfirm } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import { saveAs } from 'file-saver';
import { IPageProps } from '../../../interfaces/page-data';
import HTTPService from '../../../utils/makerequest';
import { t } from 'i18next';
import { Toast } from 'primereact/toast';

const AddLicence: React.FunctionComponent<IPageProps> = (props) => {
  const { companyId, param } = useParams<{ companyId: string; param: string }>();
  const [token, setToken] = useState('');
  const formRef = useRef(null);
  const finishRef = useRef(null);
  const [isFinishTransferVisible, setIsFinishTransferVisible] = useState(false);
  const [licenceKey, setLicenceKey] = useState('');
  const [isError, setIsError] = useState(true);
  const toast = useRef<any>(null);

  const OffLicense = (values) => {
    var token = values.activedLicence;
    setLicenceKey(values.activedLicence);
    HTTPService.GET(`/Licence/token?licenceKey=${encodeURIComponent(token)}`)
      .then((response) => {
        if (response.status === 200) {
          const tmp = response.data;
          const token = tmp.token;
          setToken(token);
          setIsError(false);
          toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: t('actived_licence_success'),
            life: 3000
          });
        } else {
          toast.current?.show({
            severity: 'error',
            summary: t('errors'),
            detail: t(response.data),
            life: 3000
          });
        }
      })
      .catch((error) => {
        console.error('Actived Licence Error:', error);
        toast.current?.show({
          severity: 'error',
          summary: t('errors'),
          detail: t('licence_activation_failed'),
          life: 3000
        });
      });
  };

  const OnlineLicense = (values) => {
    var token = values.activedLicence;
    setLicenceKey(values.activedLicence);
    HTTPService.GET(`/Licence/OnlineLicensed?licenceKey=${encodeURIComponent(token)}&companyId=${companyId}`)
      .then((response) => {
        if (response.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: t('actived_licence_success'),
            life: 3000
          });
          if (param == "1") {
            window.location.replace('/admin/customer-management/');
          }
          else {
            window.location.replace('/admin/company-management/');
          }
        } else if (response.status === 450 || response.status === 400) {
          toast.current?.show({
            severity: 'error',
            summary: t('errors'),
            detail: t(response.data),
            life: 3000
          });
        }
      })
      .catch((error) => {
        console.error('Actived Licence Error:', error);
      });
  };

  const handleFormSubmit = (activationType) => {
    formRef.current
      .validateFields()
      .then((values) => {
        if (activationType === 'offline') {
          OffLicense(values);
        } else if (activationType === 'online') {
          OnlineLicense(values);
        }
      })
      .catch((errorInfo) => {
      });
  };

  const handleUploadChange = (info) => {
    if (info.file.status !== 'uploading') {
      const formData = new FormData();
      formData.append('licenceKey', licenceKey);
      formData.append('licenceToken', info.file.originFileObj);

      HTTPService.POST(`/Licence/File?licenceKey=${licenceKey}&companyId=${companyId}`, formData)
        .then((response) => {
          if (response.status === 200) {
            toast.current?.show({
              severity: 'success',
              summary: t('successful'),
              detail: t('file_upload_success'),
              life: 3000
            });
            if (param == "1") {
              window.location.replace('/admin/customer-management/');
            }
            else {
              window.location.replace('/admin/company-management/');
            }

          }
        })
        .catch((error) => {
          toast.current?.show({
            severity: 'error',
            summary: t('errors'),
            detail: t('file_upload_error'),
            life: 3000
          });
        });
    }
  };

  const handleFinishSubmit = (values: any) => {
    finishRef.current.submit();
  };

  const handleFinishTransfer = (values) => {
    var body = {
      licenceToken: values.finishLicense,
      licenceKey: licenceKey,
      companyId: companyId
    };

    HTTPService.POST(`/Licence/add`, body)
      .then((response) => {
        if (response.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: t('finish_licence_success'),
            life: 3000
          });
          if (param == "1") {
            window.location.replace('/admin/customer-management/');
          }
          else {
            window.location.replace('/admin/company-management/');
          }

        } else if (response.status === 400) {
          toast.current?.show({
            severity: 'error',
            summary: t('errors'),
            detail: t(response.data),
            life: 3000
          });
        }
      })
      .catch((error) => {
        console.error('Finish Transfer Error:', error);
      });
  };

  const handleCopyToClipboard = () => {
    const textField = document.createElement('textarea');
    textField.innerText = token;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
    toast.current?.show({
      severity: 'success',
      summary: t('successful'),
      detail: t('token_copied'),
      life: 3000
    });
  };

  const Download = async () => {
    try {
      let fileName = 'KeyFile';
      const blob = new Blob([token], { type: 'application/octet-stream' });
      saveAs(blob, fileName);
    } catch (error) {
      toast.current?.show({
        severity: 'error',
        summary: t('errors'),
        detail: t('download_error'),
        life: 3000
      });
    }
  };

  return (
    <div>
      <Toast ref={toast} />
      <div
        style={{
          padding: '20px',
          maxWidth: '800px',
          height: 'auto',
          margin: 'auto',
          border: '1px solid black',
        }}>
        <h3 style={{ color: 'red' }}>{t('activateKey')}</h3>
        <div>
          <Form ref={formRef}>
            <Form.Item
              name='activedLicence'
              label={t('licenceKey')}
              style={{ marginBottom: '50px', height: '50px' }}>
              <Input placeholder={t('enterYourActivate')} style={{ borderRadius: 0 }} />
            </Form.Item>

            <div style={{ position: 'relative' }}>
              <div style={{ position: 'absolute', bottom: 0, right: 0 }}>
                <Popconfirm
                  title={t('offlineActivateMsg')}
                  onConfirm={() => handleFormSubmit('offline')}
                  okText={t('Yes')}
                  cancelText={t('No')}>
                  <Button type='primary' htmlType='submit'>
                    {t('offlineActivate')}
                  </Button>
                </Popconfirm>
                <Popconfirm
                  title={t('onlineActivateMsg')}
                  onConfirm={() => handleFormSubmit('online')}
                  okText={t('Yes')}
                  cancelText={t('No')}>
                  <Button type='primary'>{t('onlineActivate')}</Button>
                </Popconfirm>
              </div>
            </div>
          </Form>
        </div>
      </div>
      <div style={{ height: '40px' }}></div>

      {!isError && (
        <div
          style={{ padding: '20px', maxWidth: '800px', margin: 'auto', border: '1px solid black' }}>
          <h3 style={{ color: 'red' }}>Key</h3>
          <div style={{ overflow: 'hidden' }}>
            <p style={{ width: '750px', height: '150px' }}>{token}</p>
          </div>
          <div style={{ position: 'relative' }}>
            <div style={{ position: 'absolute', bottom: 0, right: 0 }}>
              <Button
                type='primary'
                onClick={() => {
                  handleCopyToClipboard();
                  setIsFinishTransferVisible(true);
                }}>
                {t('copy')}{' '}
              </Button>
              <Button
                type='primary'
                onClick={() => {
                  Download();
                  setIsFinishTransferVisible(true);
                }}>
                {t('download')}{' '}
              </Button>
            </div>
          </div>
        </div>
      )}
      <div style={{ height: '20px' }}></div>
      {isFinishTransferVisible && (
        <div
          style={{
            padding: '20px',
            maxWidth: '800px',
            height: 'auto',
            margin: 'auto',
            border: '1px solid black',
            marginTop: '20px',
          }}>
          <h3 style={{ color: 'red' }}>{t('finishActivateLicence')}</h3>
          <div>
            <Form ref={finishRef} onFinish={handleFinishTransfer}>
              <Form.Item
                name='finishLicense'
                label={t('finishActivateLicence')}
                style={{ marginBottom: '30px' }}>
                <Input placeholder={t('enterYourLicenceToken')} style={{ borderRadius: 0 }} />
              </Form.Item>

              <Form.Item
                name='upload'
                label={'Upload File' + Array(18).fill('\u00A0').join('')}
                valuePropName='fileList'
                getValueFromEvent={(e) => {
                  if (Array.isArray(e)) {
                    return e;
                  }
                  return e?.fileList;
                }}
                style={{ marginBottom: '30px', width: '300px', height: '50px' }}>
                <Upload name='logo' listType='text' onChange={handleUploadChange} customRequest={({ onSuccess }) => {
                  onSuccess(t('ok'));
                  return true;
                }}>
                  <Button icon={<UploadOutlined />}>{t('upload')}</Button>
                </Upload>
              </Form.Item>

              <div style={{ position: 'relative' }}>
                <div style={{ position: 'absolute', bottom: 0, right: 0 }}>
                  <Popconfirm
                    title={t('tranferFinish')}
                    onConfirm={handleFinishSubmit}
                    okText={t('Yes')}
                    cancelText={t('No')}>
                    <Button type='primary' htmlType='submit'>
                      {t('finishActivateLicence')}
                    </Button>
                  </Popconfirm>
                </div>
              </div>
            </Form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddLicence;
